import { BaseEnum } from "../../BaseEnum";

export class PreferredAccountingApproach extends BaseEnum {
  static UK = 1;
  static US = 2;

  static Codes = [this.UK, this.US];
  static _labelKeys = [
    "enums.preferred-accounting-approach.UK",
    "enums.preferred-accounting-approach.US",
  ];
}
